import { ForwardedRef, forwardRef, InputHTMLAttributes } from 'react';
import { BaseFormState } from '~/types/BaseFormState';
import { FormState } from 'react-hook-form';
import styles from './Checkbox.module.css';
import classNames from 'classnames';

type Props<TFormState extends BaseFormState> = Pick<
  InputHTMLAttributes<HTMLInputElement>,
  'onChange' | 'onBlur' | 'defaultValue' | 'value' | 'name' | 'disabled' | 'checked' | 'id'
> & {
  formState?: FormState<TFormState>;
};

function CheckboxElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLInputElement>
) {
  const { formState, name, ...rest } = props;

  return (
    <input
      className={classNames(styles.checkbox, {
        [styles.error]: name && !!formState?.errors[name]?.message,
      })}
      type="checkbox"
      name={name}
      ref={ref}
      {...rest}
    />
  );
}

export const Checkbox = forwardRef(CheckboxElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLInputElement> }
) => ReturnType<typeof CheckboxElement>;
